import { useEffect, useState } from 'react';
import { getStory } from '../data/attract';

export function StoryAttractScene({ storyId, elapsedMs }: { storyId: string; elapsedMs: number }) {
  const story = getStory(storyId);
  const [failed, setFailed] = useState(false);
  let cursor = 0;
  let activeIndex = 0;
  if (story) {
    for (let index = 0; index < story.shots.length; index += 1) {
      cursor += story.shots[index].durationMs;
      if (elapsedMs < cursor) { activeIndex = index; break; }
      activeIndex = story.shots.length - 1;
    }
  }
  const active = story?.shots[activeIndex];
  useEffect(() => setFailed(false), [active?.image]);
  if (!story || !active) return <main className="attract-scene story-attract story-attract--missing"><h1>STORY SIGNAL LOST</h1></main>;
  return (
    <main className={`attract-scene story-attract story-attract--${active.transition}`} aria-labelledby="story-title">
      {!failed ? <img key={active.image} className="story-attract__image" src={active.image} alt={active.caption ?? story.title} onError={() => setFailed(true)} /> : <div className="story-attract__fallback" role="img" aria-label="Story artwork temporarily unavailable" />}
      <div className="story-attract__shade" aria-hidden="true" />
      <header className="story-attract__header"><span>ARCADE STORY // {String(activeIndex + 1).padStart(2, '0')}</span><h1 id="story-title">{story.title}</h1></header>
      <div className="story-attract__copy">
        {active.caption && <p>{active.caption}</p>}
        {active.dialogue && <blockquote><b>{active.dialogue.speaker}</b>{active.dialogue.text}</blockquote>}
      </div>
      <div className="story-attract__marks" aria-label={`Story panel ${activeIndex + 1} of ${story.shots.length}`}>{story.shots.map((shot, index) => <i key={shot.id} className={index === activeIndex ? 'is-active' : ''} />)}</div>
    </main>
  );
}
